import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { toast } from 'material-react-toastify';

import { ConfirmationPopup } from '@/components/Popup/ConfirmationPopup/ConfirmationPopup';
import Button from '@/components/shared/Button/Button';

import { useDeleteUser } from '../../../hooks/useDeleteUser';

interface UserDeleteButtonProps {
  userId: string;
  deleted: boolean;
}

const UserDeleteButton = ({ userId, deleted }: UserDeleteButtonProps) => {
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);
  const [, setSearchParams] = useSearchParams();

  const deleteUserMutation = useDeleteUser();

  const handleDeleteUser = async () => {
    try {
      await deleteUserMutation.mutateAsync(userId);
      setIsPopupOpen(false);
      toast.success('User was deleted successfully');
      setSearchParams({});
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to delete user');
    }
  };

  return (
    <div>
      {!deleted && (
        <Button
          onClick={() => setIsPopupOpen(true)}
          label="Delete User"
          variant="danger"
          size="s"
          className="w-[128px] font-semibold"
        />
      )}

      <ConfirmationPopup
        isOpen={isPopupOpen}
        title="Delete user"
        description="Are you sure you want to delete this user? This action cannot be undone."
        handleConfirm={handleDeleteUser}
        closePopup={() => setIsPopupOpen(false)}
        variant="danger"
        confirmText={deleteUserMutation.isPending ? 'Deleting...' : 'Yes, Delete'}
      />
    </div>
  );
};

export default UserDeleteButton;
